
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Encryption',
      description: 'Military-grade encryption protocols protect your data and ensure complete privacy across all connections.',
      gradient: 'from-blue-500 to-cyan-400',
      large: true
    },
    {
      icon: 'ri-user-lock-line',
      title: 'User Privacy',
      description: 'We never log your activity or store personal information, ensuring complete anonymity.',
      gradient: 'from-indigo-500 to-purple-400',
      large: false
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Performance Optimization',
      description: 'Smart algorithms continuously optimize your device performance for the best user experience.',
      gradient: 'from-purple-500 to-pink-400',
      large: true
    },
    {
      icon: 'ri-layout-line',
      title: 'Easy Interface',
      description: 'Intuitive design makes it simple for anyone to use our applications effectively.',
      gradient: 'from-pink-500 to-rose-400',
      large: false
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features keep our apps at the cutting edge of technology.',
      gradient: 'from-orange-500 to-amber-400',
      large: true
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Our dedicated support team is always available to help you with any questions or issues.',
      gradient: 'from-teal-500 to-emerald-400',
      large: false
    }
  ];

  return (
    <div className="bg-gradient-to-b from-[#F5F3FF] to-[#FEFEFE] py-28 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-4 px-4 py-2 bg-purple-100 rounded-full">
            <span className="text-xs text-purple-700 font-semibold tracking-widest uppercase">Features</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900">Why Choose Our Applications</h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-3 gap-8">
          {/* Column 1 */}
          <div className="flex flex-col gap-8">
            <div className={`bg-white rounded-2xl p-6 shadow-sm ${features[0].large ? 'h-80' : 'h-64'}`}>
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${features[0].gradient} flex items-center justify-center mb-4`}>
                <i className={`${features[0].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{features[0].title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{features[0].description}</p>
            </div>
            <div className={`bg-white rounded-2xl p-6 shadow-sm ${features[1].large ? 'h-80' : 'h-64'}`}>
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${features[1].gradient} flex items-center justify-center mb-4`}>
                <i className={`${features[1].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{features[1].title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{features[1].description}</p>
            </div>
          </div>

          {/* Column 2 */}
          <div className="flex flex-col gap-8">
            <div className={`bg-white rounded-2xl p-6 shadow-sm ${features[2].large ? 'h-80' : 'h-64'}`}>
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${features[2].gradient} flex items-center justify-center mb-4`}>
                <i className={`${features[2].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{features[2].title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{features[2].description}</p>
            </div>
            <div className={`bg-white rounded-2xl p-6 shadow-sm ${features[3].large ? 'h-80' : 'h-64'}`}>
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${features[3].gradient} flex items-center justify-center mb-4`}>
                <i className={`${features[3].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{features[3].title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{features[3].description}</p>
            </div>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col gap-8">
            <div className={`bg-white rounded-2xl p-6 shadow-sm ${features[4].large ? 'h-80' : 'h-64'}`}>
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${features[4].gradient} flex items-center justify-center mb-4`}>
                <i className={`${features[4].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{features[4].title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{features[4].description}</p>
            </div>
            <div className={`bg-white rounded-2xl p-6 shadow-sm ${features[5].large ? 'h-80' : 'h-64'}`}>
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${features[5].gradient} flex items-center justify-center mb-4`}>
                <i className={`${features[5].icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{features[5].title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{features[5].description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
